import { useMediaQuery, useTheme } from "@mui/material"
import { useState, useEffect } from "react"

export function useAppBarHeight(): number {
    const {
        mixins: { toolbar },
        breakpoints,
    } = useTheme()

    const queryDesktop = breakpoints.up("sm")
    const queryLandscape = `${breakpoints.up("xs")} and (orientation: landscape)`

    const isDesktop = useMediaQuery(queryDesktop)
    const isLandscape = useMediaQuery(queryLandscape)

    const cssToolbar = toolbar[isDesktop ? queryDesktop : isLandscape ? queryLandscape : ""]

    return ((cssToolbar ?? toolbar) as { minHeight: number })?.minHeight ?? 0
}

export function useUseableHeight(): number {
    const appBarHeight = useAppBarHeight()
    const { height } = useWindowDimensions()
    return height - appBarHeight
}

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window
    return {
        width,
        height,
    }
}

export function useWindowDimensions() {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions())

    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions())
        }

        window.addEventListener("resize", handleResize)
        return () => window.removeEventListener("resize", handleResize)
    }, [])

    return windowDimensions
}
